import { render, staticRenderFns } from "./confirmWhitelistRepeat.popup-chunk.vue?vue&type=template&id=3221aef9"
import script from "./confirmWhitelistRepeat.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./confirmWhitelistRepeat.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports